(function () {
  var SUFFIX = ' + Gua Sha Gift';
  var LABEL_PATTERN = /Subscribe\s*&\s*Save\s*\d+%\s*\+\s*Free Shipping/i;
  var applied = false;
 
  function normalizedText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }
 
  function matches(el) {
    var text = normalizedText(el);
    return LABEL_PATTERN.test(text) && text.indexOf('Gua Sha') === -1;
  }
 
  // Collects elements from a root, diving into open shadow roots too.
  function collectElements(root, out) {
    out = out || [];
    var kids = root.children || [];
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      out.push(el);
      if (el.shadowRoot) {
        collectElements(el.shadowRoot, out);
      }
      collectElements(el, out);
    }
    return out;
  }
 
  function findTightestMatch(root) {
    var all = collectElements(root);
    var candidates = all.filter(matches);
    // Prefer the candidate with no matching element descendant among the
    // candidates — i.e. the most specific wrapper that still contains the
    // full phrase, rather than some larger ancestor section.
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var hasMatchingDescendant = candidates.some(function (other) {
        return other !== el && el.contains(other);
      });
      if (!hasMatchingDescendant) return el;
    }
    return null;
  }
 
  function patch(root) {
    if (applied) return true;
    var target = findTightestMatch(root);
    if (target) {
      target.appendChild(document.createTextNode(SUFFIX));
      applied = true;
      return true;
    }
    return false;
  }
 
  // In case the widget is already rendered by the time this runs.
  if (patch(document.body)) return;
 
  // Stay.ai's widget is client-rendered, so watch for it to appear.
  var observer = new MutationObserver(function () {
    if (patch(document.body)) {
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
 
  // Safety valve — stop watching after 15s so this never lingers indefinitely
  // if the label never shows up (e.g. out of stock, no subscription option).
  setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();